import React from "react";
import {updateQuestionInSurveyAtIdx} from "../../../../../../slices/surveyEditorSlice";
import {decideBooleanString} from "../../../../../../utils/SurveyUtils";
import {connect, useDispatch} from "react-redux";

function MatrixEditOptions(props) {
    const dispatch = useDispatch();

    const handleMultiple = () => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        newQuestionData.options.multiple = decideBooleanString(newQuestionData.options.multiple);
        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    return (
        <div className="form__group">
            <label className="form__group__check" htmlFor={"matrix_row_" + props.questionData.id}>
                <input className="form__group__check__input"
                    type="checkbox"
                    id={"matrix_row_" + props.questionData.id}
                    value={props.questionData.options.multiple}
                    onClick={(event) => {
                        handleMultiple();
                    }}
                    checked={props.questionData.options.multiple && props.questionData.options.multiple.localeCompare("true") === 0}
                />
                <span className="form__group__check__check"></span>
                <span className="form__group__check__text">Allow multiple responses per row (use checkboxes)</span>
            </label>
        </div>
    );
}

export default connect()(MatrixEditOptions);